import { useTranslation } from 'react-i18next';
import { UseMutateFunction } from 'react-query';
import { DefaultSelect } from '../../../../../../common/DefaultSelect/DefaultSelect';
import usePlanStore from '../../../../../../../../../store/planStore';
import { ApiResponse } from '../../../../../../../../../api/services/mediaPlanning/types';
import { TVTouchpointSetup } from '../../../../../../components/Touchpoints/interfaces';

interface TargetGroupsSelectProps {
  fetchTVSetup: UseMutateFunction<
    ApiResponse<TVTouchpointSetup>,
    any,
    string | undefined,
    unknown
  >;
}

export default function TargetGroupSelect({
  fetchTVSetup,
}: TargetGroupsSelectProps) {
  const { t } = useTranslation();
  const { countryForms, selectedCountry, updateTVConfig } = usePlanStore();

  const { offline } = countryForms[selectedCountry!];

  if (!selectedCountry) {
    return null;
  }

  const handleChangeStateValues = (key: string, value: string | number) => {
    updateTVConfig(selectedCountry!, { [key]: value });
  };

  return (
    <DefaultSelect
      value={offline?.tv?.targetGroup ?? ''}
      onChange={(newValue) => {
        handleChangeStateValues('targetGroup', newValue.value ?? '');
        fetchTVSetup(String(newValue.value));
      }}
      items={
        offline?.tv?.targetGroups?.map((targetGroup) => ({
          name:
            targetGroup === offline?.tv?.recommendedTargetGroup
              ? `${targetGroup} (recommended)`
              : targetGroup,
          value: targetGroup,
        })) || []
      }
      selectName={
        !offline?.tv?.targetGroup
          ? t('mediaPlanning.placeholders.targetGroup')
          : t('mediaPlanning.targetGroup')
      }
      labelId="target-group"
    />
  );
}
